import React, { useMemo } from 'react'
import { useBusinessTime } from '@/redux/api/businessClockApi'
import { OperationDateContext } from './OperationDateContext'

export function OperationDateProvider({ children }: { children: React.ReactNode }) {
  const result = useBusinessTime()
  const date = result.data?.businessDate
  const unavailable = !!result.error
  const value = useMemo(() => ({ date, unavailable }), [date, unavailable])
  return <OperationDateContext.Provider value={value}>
    {children}
  </OperationDateContext.Provider>
}
